import { Box, Typography } from "@mui/material"
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers"
import theme from "css/theme/light"
import moment from "moment"
import React from "react"
import { StyledFormLabel } from "shared/styled/Global"
import { IFormDateFieldProps } from "./formdatetimepicker.interface"
import { useTranslation } from "react-i18next"

const FormDateTimePicker: React.FC<IFormDateFieldProps> = (props) => {
  const { labelKey, labelDefault, value, handleChange, optional, error, helperText, handleBlur, time } = props
  const { t } = useTranslation()

  const textFieldTemplate = {
    textField: {
      sx: {
        background: theme.palette.background.paper,
        width: "100%"
      },
      onChange: (newValue: React.ChangeEvent<HTMLInputElement>) => {
        return handleChange && handleChange(newValue)
      },
      onBlur: handleBlur,
      error,
      helperText
    }
  }
  return (
    <Box>
      <StyledFormLabel>
        <Typography variant="labelLarge" fontWeight={500}>
          {t(labelKey || "", { defaultValue: labelDefault })}
          {!optional && "*"}
        </Typography>
      </StyledFormLabel>
      {time ? (
        <DateTimePicker
          value={value ? moment(value) : null}
          format={"YYYY-MM-DD HH:mm"}
          onChange={(newValue: any) => {
            handleChange && handleChange(newValue)
          }}
          slotProps={textFieldTemplate}
        />
      ) : (
        <DatePicker
          value={value ? moment(value) : null}
          format={"YYYY-MM-DD"}
          onChange={(newValue: any) => {
            handleChange && handleChange(newValue)
          }}
          slotProps={textFieldTemplate}
        />
      )}
    </Box>
  )
}

export default FormDateTimePicker
